export const isObject = (value: any) => {
  return value !== null && typeof value === "object";
};

export const isObjectOrArray = (value: any) => {
  return isObject(value) || Array.isArray(value);
};
